<script>
import {
  selectedMetricConfig,
} from '@/config/sectionFiltersConfig';

import useSectionState from '@/state/useSectionState';
import useFilterState from '@/state/useFilterState';

import UnderlineBtn from '@/components/UnderlineBtn/UnderlineBtn.vue';

import { track } from '@/utils/analytics';

export default {
  components: {
    UnderlineBtn,
  },
  setup() {
    const { sectionMetrics, sectionName } = useSectionState();
    const { selectedMetric, setSelectedMetric } = useFilterState();

    const handleClick = (value) => {
      track(`metric - ${value} - ${sectionName.value}`);
      setSelectedMetric(value);
    };

    return {
      selectedMetricConfig,
      sectionMetrics,
      selectedMetric,
      handleClick,
    };
  },
};
</script>

<template>
  <div
    v-if="sectionMetrics.length > 1"
    class="flex w-full border-b border-base-400"
  >
    <UnderlineBtn
      v-for="metric in sectionMetrics"
      :key="metric.name"
      data-testid="btn"
      :value="metric.name"
      :is-active="selectedMetric === metric.name"
      :text="metric.placeholder"
      @click="handleClick"
    />
  </div>
</template>
